import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PayixButton from '../../containers/payix-button';
import PaymentMethods from '../../components/application/payment-methods';
import { toUSD, checkDecimal } from '../../helpers/formatters';

class EditScheduleModal extends Component {
  /**
   * Receive the props and init the state.
   */
  constructor(props) {
    super(props);

    this.state = {
      amount: props.amount,
      scheduleDate: moment(this.props.scheduleDate),
      paymentMethod: props.selectedPaymentMethod
    }
  }
  
  /**
   * Handler for on change event on the amount field.
   * 
   * @param event
   */
  handleChangeAmount = (event) => {
    this.setAmount(event.target.value);
  }

  /**
   * Set the new value for amount.
   * 
   * @param value
   */
  setAmount = (value) => {
    value = checkDecimal(value);

    if (value) {
      this.setState({
        amount: value[0]
      });
    }
  }

  /**
   * Set the selected schedule date.
   * 
   * @param selectedDated An array with the selected dates.
   * @param dateStr - The date in string format.
   */
  setScheduleDate = (date) => {
    this.setState({
      scheduleDate: date
    });
  }

  /**
   * Set the selected schedule date on blur event.
   * 
   */
  setScheduleDateOnBlur = ({target:{value}})=>{
    this.setState({
      scheduleDate: moment(value)
    });
  }

  /**
   * Handle when payment method is changed.
   * 
   * @param id - The id of the selected payment method.
   */
  handleChangePaymentMethod = (index) => {
    let paymentMethod = this.props.paymentMethods[index];

    this.setState({
      paymentMethod: paymentMethod
    });
  }

  /**
   * Get the total amount to pay.
   */
  getAmount() {
    let amount = this.state.amount === '' ? 0 : this.state.amount;
    
    return parseFloat(amount);
  }

  /**
   * Check if all form's fields are filled.
   */
  isFormFull() {
    let { amount, paymentMethod, scheduleDate } = this.state;
    
    if (amount && paymentMethod && scheduleDate) {
      return true;
    }

    return false;
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.onSubmit({
      amount: parseFloat(this.getAmount()).toFixed(2),
      scheduleDate: this.state.scheduleDate.format('YYYY-MM-DD'),
      paymentMethod: this.state.paymentMethod
    });
  }

  /**
   * Render a dropdown with the payment methods.
   */
  renderPaymentMethods = () => {
    return (
      <PaymentMethods 
        paymentMethods={this.props.paymentMethods} 
        selected={this.state.paymentMethod}
        onChange={this.handleChangePaymentMethod}
        syncWithStore={false}
        allowAddNew={false} />
    )
  }

  /**
   * Render the component view.
   */
  render() {
    let minDate = moment().add(1, 'days');

    return (
      <div>
        <div className="modal__header">
          <div className="modal__header-content--centered">
            <h3 className="modal-title common-title">
              Edit Schedule Payment
            </h3>
          </div>
        </div>
        
        <div className="modal__body">
          <div className="modal__body-content--pad35">
            <div>
              <div className="flex-block flex-block--space-between">
                <div className="line-height-15">
                  <span className="money money--block">{this.props.loanNumber}</span>
                  <span className="load-account__money-legend">Account Number</span>
                </div>

                <div className="align-right line-height-15">
                  <span className="money money--block">
                    {toUSD(this.props.regularPmtAmt)}
                  </span>
                  <span className="load-account__money-legend">Regular Payment</span>
                </div>
              </div>

              <form onSubmit={this.handleSubmit}>
                <hr className="hr" />
                { this.renderPaymentMethods() }
                <hr className="hr" />

                <div className="form-group margin-top-15">
                  <label className="form-group__label">Enter amount you would like to pay</label>
                  <div>
                    {/**
                      ** Render the input for the amount.
                      **/}
                    <input 
                      className="money-input-simple" 
                      type="text" 
                      maxLength="13"
                      value={this.state.amount}
                      onChange={this.handleChangeAmount} />
                  </div>
                </div>

                <div className="load-account__total">
                  <span className="gothammedium-font">Total Payable</span>
                  <span className="gothammedium-font">{toUSD(this.getAmount())}</span>
                </div>

                <hr className="hr" />

                <div className="form-group loan-account__schedule-date">
                  <label className="form-group__label">Schedule Date</label>
                  <DatePicker
                    selected={this.state.scheduleDate}
                    onChange={this.setScheduleDate}
                    onBlur={this.setScheduleDateOnBlur}
                    className="datepicker"
                    minDate={minDate}
                  />
                </div>

                <div className="form-group margin-top-20">
                  <PayixButton className="button--full" type="submit" disabled={!this.isFormFull()}>
                    SCHEDULE A PAYMENT
                  </PayixButton>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
 
export default EditScheduleModal;


// WEBPACK FOOTER //
// ./src/components/schedule/edit-schedule-modal.js